import React, { useEffect, useState } from 'react';
import './ContentSidebar.css';

const ContentSidebar = ({
    items,
    visible,

    onViewPDF,
    setSelectedRecord,
    renderActionButton,
    selectedRecord,
    onChange
}) => {
    const [activeItemId, setActiveItemId] = useState(selectedRecord?.contentId || null);

    // useEffect(() => {

    //     onpauseVideo();
    // }
    //     , [selectedRecord]);

    // Function to determine the resource type for styling
    const getResourceType = (link) => {
        if (!link) return "default";
        const lower = link.toLowerCase();
        if (lower.includes("youtube.com") || lower.includes("youtu.be")) return "youtube";
        if (lower.endsWith(".mp4") || lower.endsWith(".mov")) return "video";
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.startsWith("http://") || lower.startsWith("https://")) return "website";
        return "default";
    };

  const handleItemClick = (item) => {
  setActiveItemId(item.contentId);
  setSelectedRecord(item);
  renderActionButton(item)();

  if (onChange) {
    onChange(item.contentId); // ✅ call parent handler
  }
};

useEffect(() => {
    if (selectedRecord?.contentId) {
        setActiveItemId(selectedRecord.contentId);
    }
}, [selectedRecord]);


    return (
        <div className="content-sidebar-items-container">
            {/* Scrollable wrapper for all items */}
            <div className="content-sidebar-items-wrapper">
                {items && items.length > 0 ? (
                    items.map((item) => {
                        const resourceType = getResourceType(item.resourceLink);
                        const isActive = activeItemId === item.contentId;

                        return (
                            <div
                                key={item.id || item.courseContentId}
                                className={isActive ? "content-sidebar-item-active" : "content-sidebar-item"}
                                data-type={resourceType}
                                onClick={() => {
                                    console.log("item clicked ", item);
                                    // setActiveItemId(item.contentId);
                                    // setSelectedRecord(item);
                                    // renderActionButton(item)();
                                    handleItemClick(item)
                                }}
                                style={{
                                    position: 'relative',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <div className="content-sidebar-text">
                                    {item.title}
                                </div>

                                {/* Progress indicator - uncomment if you want to show progress */}
                                {/* {progressPercentage > 0 && (
                                    <div 
                                        className="content-sidebar-item-progress"
                                        style={{ width: `${progressPercentage}%` }}
                                    />
                                )} */}
                            </div>
                        );
                    })
                ) : (
                    <div className="content-sidebar-empty">
                        No content available
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContentSidebar;